export default __webpack_public_path__ + "static/media/favicon-32x32.3b079241.png";